// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationReconciliationModal > .Modal-Dialog > .Modal-Content {
  padding: 2rem;
}
.LocationReconciliationModal > .Modal-Dialog > .Modal-Content > .Modal-Header {
  padding: 0;
  border-bottom: none !important;
  flex-direction: row;
}
.LocationReconciliationModal .FormField .FormField-Wrapper {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.LocationReconciliationModal .group-input .form-label {
  margin: 0;
  font-weight: 700;
}
.LocationReconciliationModal .group-input .LocationInput,
.LocationReconciliationModal .group-input .form-control {
  font-size: 12px;
  padding: 8px 12px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e3e8ef;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/LocationReconciliationModal/styles.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;AADN;AAEM;EACE,UAAA;EACA,8BAAA;EACA,mBAAA;AAAR;AAKI;EACE,0CAAA;AAHN;AAQI;EACE,SAAA;EACA,gBAAA;AANN;AAQI;;EAEE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,yBAAA;AANN","sourcesContent":[".LocationReconciliationModal {\n  > .Modal-Dialog {\n    > .Modal-Content {\n      padding: 2rem;\n      > .Modal-Header {\n        padding: 0;\n        border-bottom: none !important;\n        flex-direction: row;\n      }\n    }\n  }\n  .FormField {\n    .FormField-Wrapper {\n      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  .group-input {\n    .form-label {\n      margin: 0;\n      font-weight: 700;\n    }\n    .LocationInput,\n    .form-control {\n      font-size: 12px;\n      padding: 8px 12px;\n      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n      border: 1px solid #e3e8ef;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
